import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WebNavigationService} from '../../navigation.service';

@Component({
  selector: 'app-conciliacion-option',
  templateUrl: './conciliacion-option.component.html',
  styleUrls: ['./conciliacion-option.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConciliacionOptionComponent implements OnInit {

  constructor(private navigationService: WebNavigationService) {
  }

  ngOnInit() {
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

  get expandConciliacion() {
    return this.navigationService.expandConciliacion;
  }

  selectOption(option) {
    this.navigationService.selectOption(option);
  }

  selectConciliacionOption(conciliacionOption) {
    this.navigationService.selectConciliacionOption(conciliacionOption);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/conciliacion/conciliacion-option.component.ts